"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PatientInsuranceCardStatusEnum = exports.PatientInsuranceBenefitChangeStatusEnum = exports.PatientInsuranceBenefitChangeOperationEnum = void 0;
var PatientInsuranceCardStatusEnum = /*#__PURE__*/function (PatientInsuranceCardStatusEnum) {
  PatientInsuranceCardStatusEnum["Pending"] = "pending";
  PatientInsuranceCardStatusEnum["Active"] = "active";
  PatientInsuranceCardStatusEnum["Eligible"] = "eligible";
  PatientInsuranceCardStatusEnum["Ineligible"] = "ineligible";
  PatientInsuranceCardStatusEnum["OptedOut"] = "opted-out";
  PatientInsuranceCardStatusEnum["Draft"] = "draft";
  PatientInsuranceCardStatusEnum["Migrated"] = "migrated";
  return PatientInsuranceCardStatusEnum;
}({});
exports.PatientInsuranceCardStatusEnum = PatientInsuranceCardStatusEnum;
var PatientInsuranceBenefitChangeOperationEnum = /*#__PURE__*/function (PatientInsuranceBenefitChangeOperationEnum) {
  PatientInsuranceBenefitChangeOperationEnum["AutoInitial"] = "auto-initial";
  PatientInsuranceBenefitChangeOperationEnum["AutoRefresh"] = "auto-refresh";
  PatientInsuranceBenefitChangeOperationEnum["AutoLongTermRefresh"] = "auto-longterm";
  PatientInsuranceBenefitChangeOperationEnum["AutoClaim"] = "auto-claim";
  PatientInsuranceBenefitChangeOperationEnum["Manual"] = "manual";
  PatientInsuranceBenefitChangeOperationEnum["ManualAutoParsed"] = "manual-auto-parsed";
  PatientInsuranceBenefitChangeOperationEnum["InsuranceCardStatusAutoUpdate"] = "insurance-card-status-auto-update";
  return PatientInsuranceBenefitChangeOperationEnum;
}({});
exports.PatientInsuranceBenefitChangeOperationEnum = PatientInsuranceBenefitChangeOperationEnum;
var PatientInsuranceBenefitChangeStatusEnum = /*#__PURE__*/function (PatientInsuranceBenefitChangeStatusEnum) {
  PatientInsuranceBenefitChangeStatusEnum["ParsingFailed"] = "parsing-failed";
  PatientInsuranceBenefitChangeStatusEnum["Eligible"] = "eligible";
  PatientInsuranceBenefitChangeStatusEnum["Ineligible"] = "ineligible";
  return PatientInsuranceBenefitChangeStatusEnum;
}({});
exports.PatientInsuranceBenefitChangeStatusEnum = PatientInsuranceBenefitChangeStatusEnum;